
const TechnologyFocusSection = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-slate-900/30 to-slate-800/30 relative overflow-hidden">
      {/* 精致背景装饰 */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-32 right-20 w-80 h-80 bg-cyan-600/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-32 left-20 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative container mx-auto px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="px-4 py-2 bg-cyan-600/20 text-cyan-300 rounded-full text-sm font-medium border border-cyan-400/30">
              Innovation Focus
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-light text-white mb-8 leading-tight">
            Focus on <strong className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">High-Tech Innovation</strong>
          </h2>
          <p className="text-xl text-white/80 max-w-4xl mx-auto font-light leading-relaxed">
            Specializing in breakthrough technologies that drive the future of industry and transform business landscapes
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-20 items-center mb-24">
          <div className="space-y-10">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/10 to-blue-600/10 rounded-3xl blur-xl"></div>
              <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-10 hover:border-cyan-400/40 transition-all duration-500">
                <h3 className="text-4xl font-light text-white mb-6 leading-tight">
                  Cutting-Edge <strong className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">Technology Areas</strong>
                </h3>
                <p className="text-lg text-white/80 leading-relaxed font-light">
                  Our expertise spans the most promising high-growth technology fields, connecting overseas innovators with new market opportunities and empowering clients to leapfrog competition through strategic innovation.
                </p>
              </div>
            </div>

            <div className="space-y-6">
              <div className="group relative">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600/5 to-cyan-600/5 rounded-2xl blur-lg group-hover:blur-xl transition-all duration-300"></div>
                <div className="relative flex items-center gap-6 p-6 bg-white/8 backdrop-blur-md border border-white/20 rounded-2xl hover:bg-white/12 hover:border-cyan-400/40 transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 border border-blue-400/30">
                    <i className="ri-settings-3-line text-2xl text-blue-400"></i>
                  </div>
                  <div className="flex-1">
                    <h5 className="text-white font-semibold mb-2 text-lg group-hover:text-cyan-100 transition-colors duration-300">Industry 4.0</h5>
                    <p className="text-cyan-300 font-medium">Smart manufacturing and automation solutions</p>
                  </div>
                </div>
              </div>

              <div className="group relative">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600/5 to-cyan-600/5 rounded-2xl blur-lg group-hover:blur-xl transition-all duration-300"></div>
                <div className="relative flex items-center gap-6 p-6 bg-white/8 backdrop-blur-md border border-white/20 rounded-2xl hover:bg-white/12 hover:border-cyan-400/40 transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 border border-blue-400/30">
                    <i className="ri-wifi-line text-2xl text-blue-400"></i>
                  </div>
                  <div className="flex-1">
                    <h5 className="text-white font-semibold mb-2 text-lg group-hover:text-cyan-100 transition-colors duration-300">Internet of Things (IoT)</h5>
                    <p className="text-cyan-300 font-medium">Connected devices and smart systems</p>
                  </div>
                </div>
              </div>

              <div className="group relative">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600/5 to-cyan-600/5 rounded-2xl blur-lg group-hover:blur-xl transition-all duration-300"></div>
                <div className="relative flex items-center gap-6 p-6 bg-white/8 backdrop-blur-md border border-white/20 rounded-2xl hover:bg-white/12 hover:border-cyan-400/40 transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 border border-blue-400/30">
                    <i className="ri-cpu-line text-2xl text-blue-400"></i>
                  </div>
                  <div className="flex-1">
                    <h5 className="text-white font-semibold mb-2 text-lg group-hover:text-cyan-100 transition-colors duration-300">Advanced Electronics</h5>
                    <p className="text-cyan-300 font-medium">Next-generation electronic components and systems</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/20 to-blue-600/20 rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
            <div className="relative overflow-hidden rounded-3xl border border-white/20 group-hover:border-cyan-400/40 transition-all duration-500">
              <img 
                alt="High-Tech Innovation Focus Areas" 
                className="w-full h-[500px] object-cover transition-transform duration-700 group-hover:scale-110" 
                src="https://public.readdy.ai/ai/img_res/00f23a9daaa284432464a61d5925f1c4.jpg.0%20smart%20manufacturing%2C%20IoT%20connected%20devices%2C%20and%20advanced%20electronics%2C%20modern%20high-tech%20laboratory%20environment%20with%20blue%20lighting%20and%20sophisticated%20equipment%2C%20cutting-edge%20technology%20development%20workspace&width=600&height=500&seq=tech-focus&orientation=landscape"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/10 to-blue-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-8 hover:bg-white/12 hover:border-cyan-400/40 transition-all duration-500 hover:transform hover:scale-105 h-full">
              <div className="w-20 h-20 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 rounded-3xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300 border border-cyan-400/30">
                <i className="ri-lightbulb-line text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-6 group-hover:text-cyan-100 transition-colors duration-300">Innovation Sourcing</h3>
              <p className="text-white/80 mb-6 leading-relaxed font-light text-lg">
                Identifying breakthrough technologies from leading innovation centers in Europe and North America
              </p>
              <div className="border-t border-white/20 pt-6">
                <p className="text-cyan-300 font-medium">Focus: Technology scouting and evaluation</p>
              </div>
            </div>
          </div>

          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/10 to-blue-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-8 hover:bg-white/12 hover:border-cyan-400/40 transition-all duration-500 hover:transform hover:scale-105 h-full">
              <div className="w-20 h-20 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 rounded-3xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300 border border-cyan-400/30">
                <i className="ri-rocket-line text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-6 group-hover:text-cyan-100 transition-colors duration-300">Market Integration</h3>
              <p className="text-white/80 mb-6 leading-relaxed font-light text-lg">
                Seamless integration of advanced technologies into target markets with localized support
              </p>
              <div className="border-t border-white/20 pt-6">
                <p className="text-cyan-300 font-medium">Focus: Commercialization and deployment</p>
              </div>
            </div>
          </div>

          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/10 to-blue-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-8 hover:bg-white/12 hover:border-cyan-400/40 transition-all duration-500 hover:transform hover:scale-105 h-full">
              <div className="w-20 h-20 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 rounded-3xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300 border border-cyan-400/30">
                <i className="ri-trophy-line text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-6 group-hover:text-cyan-100 transition-colors duration-300">Competitive Advantage</h3>
              <p className="text-white/80 mb-6 leading-relaxed font-light text-lg">
                Empowering clients to leapfrog competition through strategic technology adoption
              </p>
              <div className="border-t border-white/20 pt-6">
                <p className="text-cyan-300 font-medium">Focus: Strategic technology implementation</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnologyFocusSection;
